import React from "react";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import starimg from "../../images/stars.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./clientFeedback.css";

function Client() {
  const [testimonials, setTestimonials] = useState();

  useEffect(() => {
    fetch("/testimonials")
      .then((response) => response.json())
      .then((response) => setTestimonials(response));
  }, []);

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,

    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: false,
    autoplay: true,
    speed: 800,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
        },
      },
      // {
      //   breakpoint: 620,
      //   settings: {
      //     slidesToShow: 1,
      //   },
      // },
    ],
  };

  return (
    <div className="container client_container">
      <p style={{ color: "#fff" }} className="container_heading">
        Client's{" "}
        <span className="heading_first" style={{ border: "none" }}>
          Feedback
        </span>
      </p>

      {/* <p className="clientfeed_quote_sign">"</p> */}

      <div className="feedback_cards">
        <Slider {...settings}>
          {testimonials &&
            testimonials.map((review) => (
              <div className="feedback_card">
                <div
                  style={{ maxWidth: "90%" }}
                  className="feedback_card_top_cont"
                >
                  <p className="feedback_card_title">{review.title}</p>

                  <img src={starimg} className="stars" />

                  {/* <div> */}
                  <p className="feedback_card_content">{review.content}</p>

                  {/* </div> */}
                </div>
                <p className="feedback_card_author">{review.author}</p>
              </div>
            ))}
        </Slider>
      </div>
    </div>
  );
}

export default Client;
